import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ToWords } from 'to-words';

pdfMake.vfs = pdfFonts.vfs;

export const generateNeftChallanPdf = (voucher) => {
  if (!voucher) {
    console.error("No voucher data provided");
    return;
  }


  // Helper Functions
  const formatAmount = (num) => {
    if (!num && num !== 0) return "0.00";
    return Number(num).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const toWords = new ToWords({ localeCode: 'en-IN' });

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString("en-GB");
  };

  const numberToWords = (num) => {
    if (!num && num !== 0) return "Zero Rupees Only";
    try {
      return toWords.convert(Number(num), { currency: true });
    } catch (error) {
      console.error("Error converting to words:", error);
      return `${num} Rupees Only`;
    }
  };

  // Data preparation
  const totalAmount = voucher.total_amount || 0;
  const account_no = voucher.account_no || 0;

  const charges = 0;
  const grandTotal = Number(totalAmount) + Number(charges);

  const data = {
    sender_name: "KP & GRANDSONS PVT. LTD.",
    sender_address: "K-5,DHEBUR STEEL CITY, AVANTI VIHAR",
    sender_phone: "9302122967",
    sender_email: "kpgrandsons@rediffmail.com",
    sender_account_type: "Current",
    sender_account_no: account_no,

    amount: totalAmount,
    amount_in_words: voucher.amount_in_words || numberToWords(totalAmount),
    charges: charges,
    total_amount: grandTotal,
    total_in_words: numberToWords(grandTotal),

    cheque_no: voucher.cheque_number || voucher.transaction_number || "",

    benef_ifsc: voucher.ifsc_code || "",
    benef_bank: voucher.bank_name || "",
    benef_branch: voucher.branch_name || "",
    benef_branch_address: voucher.branch_name || "",
    benef_account_type: "Savings",
    benef_account_no: voucher.account_number || "",
    benef_name: voucher.supplier_name ||
      voucher.expense_name ||
      voucher.advanceworker_name ||
      voucher.imprest_name ||
      voucher.party_name ||
      voucher.transporter_name || "N/A",
    benef_address: voucher.address || "",
    benef_contact: voucher.phone || "",

    date: formatDate(voucher.payment_date || new Date()),
  };

  try {
    const doc = {
      pageSize: 'A4',
      pageMargins: [30, 30, 30, 30],
      content: [
        // ==================== HEADER ====================
        {
          table: {
            widths: ['*'],
            body: [
              [{
                stack: [
                  {
                    text: 'INDIAN OVERSEAS BANK, RAIPUR',
                    alignment: 'center',
                    bold: true,
                    fontSize: 12,
                    margin: [0, 0, 0, 3]
                  },
                  {
                    text: 'NEFT REMITTANCE CHALLAN BRANCH COPY',
                    alignment: 'center',
                    bold: true,
                    fontSize: 11
                  }
                ],
                border: [true, true, true, true],
                fillColor: "#f5f5f5"   // 🔥 Background color added here
              }]
            ]
          },
          margin: [0, 0, 0, 10]
        },

        // ==================== PART A - SENDER (Points 1-7 in ONE TABLE) ====================
        {
          text: 'A) Particulars of Sender',
          bold: true,
          fontSize: 11,
          margin: [0, 5, 0, 5]
        },

        {
          table: {
            widths: ['35%', '65%'],
            body: [
              // Point 1
              [
                { text: '1. Name:', fontSize: 9 },
                { text: data.sender_name, bold: true, fontSize: 9 }
              ],
              // Point 2
              [
                { text: '2. Address:', fontSize: 9 },
                { text: data.sender_address, bold: true, fontSize: 9 }
              ],
              // Point 3
              [
                { text: '3. Contact No. Phone:', fontSize: 9 },
                { text: data.sender_phone, bold: true, fontSize: 9 }
              ],
              [
                { text: '   Mobile:', fontSize: 9 },
                { text: data.sender_phone, bold: true, fontSize: 9 }
              ],
              [
                { text: '   Email:', fontSize: 9 },
                { text: data.sender_email, bold: true, fontSize: 9 }
              ],
              // Point 4
              [
                { text: '4. Type of account:', fontSize: 9 },
                { text: data.sender_account_type, fontSize: 9 }
              ],
              [
                { text: '   A/c NO.:', fontSize: 9 },
                { text: data.sender_account_no, bold: true, fontSize: 9 }
              ],

              // Point 5 - Amount Section
              [
                {
                  text: '5. Amount to be remitted:',
                  fontSize: 9,
                  bold: true,
                  colSpan: 2,
                  fillColor: "#f5f5f5"   
                },
                {}
              ],
              [
                {
                  text: `   RS. ${formatAmount(data.amount)}`,
                  bold: true,
                  fontSize: 10,
                  fillColor: "#f5f5f5"   
                },
                {
                  text: '(Rupees)',
                  italics: true,
                  fontSize: 8,
                  alignment: 'right',
                  fillColor: "#f5f5f5"   
                }
              ],
              [
                {
                  text: `   (${data.amount_in_words})`,
                  italics: true,
                  fontSize: 8,
                  colSpan: 2
                },
                {}
              ],

              // Point 6 - Charges
              [
                { text: '6. Amount of Remittance charges:', bold: true, fontSize: 9 },
                { text: `RS. ${formatAmount(data.charges)}`, fontSize: 9, alignment: 'right' }
              ],
              [
                { text: '   Total:', bold: true, fontSize: 10 ,fillColor: "#f5f5f5"    },
                { text: `RS. ${formatAmount(data.total_amount)}`, bold: true, fontSize: 10, alignment: 'right' ,fillColor: "#f5f5f5"    }
              ],
              [
                {
                  text: `   (${data.total_in_words})`,
                  italics: true,
                  fontSize: 8,
                  colSpan: 2
                },
                {}
              ],

              // Point 7 - Cheque
              [
                { text: '7. Please find enclosed Cheque no.', bold: true, fontSize: 9 ,fillColor: "#f5f5f5"   },
                { text: data.cheque_no, fontSize: 9, alignment: 'right',fillColor: "#f5f5f5"    }
              ],
              [
                {
                  text: `   RS. ${formatAmount(data.total_amount)} Debit my account`,
                  bold: true,
                  fontSize: 9,
                  colSpan: 2,
                  fillColor: "#f5f5f5"   
                },
                {}
              ],
              [
                {
                  text: `   (${data.total_in_words})`,
                  italics: true,
                  fontSize: 8,
                  colSpan: 2
                },
                {}
              ]
            ]
          },
          margin: [0, 0, 0, 10]
        },

        // ==================== PART B - BENEFICIARY ====================
        {
          text: 'B) Particulars of Beneficiary',
          bold: true,
          fontSize: 11,
          margin: [0, 10, 0, 5]
        },

        {
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                { text: '1. IFSC Code:', fontSize: 9 },
                { text: data.benef_ifsc, fontSize: 9, bold: true ,fillColor: "#f5f5f5"   }
              ],
              [
                { text: '2. Account with Bank:', fontSize: 9 },
                { text: data.benef_bank, fontSize: 9 }
              ],
              [
                { text: '   Name of Bank:', fontSize: 9 },
                { text: data.benef_bank, fontSize: 9 }
              ],
              [
                { text: '   Branch:', fontSize: 9 },
                { text: data.benef_branch, fontSize: 9 }
              ],
              [
                { text: '3. Branch Address:', fontSize: 9 },
                { text: data.benef_branch_address, fontSize: 9 }
              ],
              [
                { text: '4. Type of Account:', fontSize: 9 },
                { text: data.benef_account_type, fontSize: 9 }
              ],
              [
                { text: '5. Account No.:', fontSize: 9 },
                { text: data.benef_account_no, fontSize: 9, bold: true }
              ],
              [
                { text: '6. Beneficiary\'s Name:', fontSize: 9 },
                { text: data.benef_name, fontSize: 9, bold: true }
              ],
              [
                { text: '7. Beneficiary\'s Address:', fontSize: 9 },
                { text: data.benef_address, fontSize: 9 }
              ],
              [
                { text: '8. Beneficiary\'s Contact No.:', fontSize: 9 },
                { text: data.benef_contact, fontSize: 9 }
              ],
              [
                { text: 'Date:', fontSize: 9,fillColor: "#f5f5f5"    },
                { text: data.date, fontSize: 9, bold: true,fillColor: "#f5f5f5"    }
              ],
            ]
          },
          margin: [0, 0, 0, 1]
        },

        // ==================== SIGNATURE ====================
        {
          table: {
            widths: ['50%', '50%'],
            body: [
              [
                {
                  text: 'Applicant\'s Signature',
                  bold: true,
                  fontSize: 10,
                  margin: [0, 20, 0, 0],
                  alignment: 'center'
                },
                { text: '', border: [true, true, true, true] }
              ]
            ]
          },
          margin: [0, 0, 0, 20]
        },

        // ==================== BANK USE ONLY ====================
        {
          table: {
            widths: ['*'],
            body: [
              [{
                text: 'NEFT UTR NO.',
                bold: true,
                fontSize: 10,
                margin: [0, 5, 0, 5],
                fillColor: "#f5f5f5"   
              }],
            ]
          },
          margin: [0, 0, 0, 0.5]
        },

        {
          table: {
            widths: ['40%', '30%', '30%'],
            body: [
              [
                {
                  text: 'Received for remittance through NEFT',
                  bold: true,
                  fontSize: 9,
                  rowSpan: 3,
                  margin: [0, 20, 0, 0]
                },
                { text: 'Branch Seal', fontSize: 9, alignment: 'center' },
                { text: '', fontSize: 9 }
              ],
              [
                {},
                { text: '', margin: [0, 20, 0, 20] },
                { text: '', margin: [0, 20, 0, 20] }
              ],
              [
                {},
                { text: 'Date', fontSize: 9, alignment: 'center' },
                { text: 'Authorised Signatory', fontSize: 9, alignment: 'center' }
              ],
            ]
          },
          margin: [0, 0, 0, 10]
        },

        // ==================== FOOTER NOTE ====================
        {
          text: '** The Remittance Facility to a Bank other than Nepal SBI Bank Ltd., will be operational after RBI\'s notification',
          fontSize: 7,
          italics: true,
          margin: [0, 10, 0, 0],
          alignment: 'center'
        }
      ]
    };

    pdfMake.createPdf(doc).open();

  } catch (error) {
    console.error("❌ Error generating NEFT PDF:", error);
    alert("Failed to generate NEFT Challan. Please check console for details.");
  }
};